import { ClipboardCopyIcon } from '@radix-ui/react-icons';
import { Box, IconButton } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { t } from 'i18next'; // Replace with your translation library if different
import { RADIX } from 'lib_ts/enums/radix-ui';

interface IProps {
  value?: string;
  label?: string;
}

// Parent will need to provide a { position: relative } to position properly
const FloatingCopyButton = (props: IProps) => {
  return (
    <Box position="absolute" right={RADIX.FLEX.PAD.SM} top={RADIX.FLEX.PAD.SM}>
      <IconButton
        size={RADIX.BUTTON.SIZE.SM}
        color={RADIX.COLOR.NEUTRAL}
        variant="soft"
        onClick={() => {
          if (props.value) {
            navigator.clipboard.writeText(props.value);

            NotifyHelper.success({
              message_md: t('common.x-copied-to-clipboard', {
                x: props.label || 'Text',
              }),
            });
          }
        }}
      >
        <ClipboardCopyIcon />
      </IconButton>
    </Box>
  );
};

export default FloatingCopyButton;
